import moment from 'moment'

import { gql, useQuery } from '@apollo/client'

import { useCurrentUserId } from './use-current-user-id'
import { useIsClient } from './use-is-client'

const GET_USER_REGISTRATION_DATE = gql`
  query GetUserRegistrationDate($id: ID!) {
    user(id: $id) {
      createdAt
    }
  }
`

const oldFeaturesThresholdDate = '2024-08-01 00:00:00'

export const oldFeaturesEnabled = (registrationDate) =>
  moment(registrationDate).isBefore(oldFeaturesThresholdDate)

export const useFeatureEnabledByDate = () => {
  const userId = useCurrentUserId()
  const isClient = useIsClient()
  const { data, loading } = useQuery(GET_USER_REGISTRATION_DATE, {
    variables: {
      id: userId,
    },
    skip: !userId,
  })

  if (!isClient) return [true, false]

  const registrationDate = data?.user.createdAt

  return [loading, oldFeaturesEnabled(registrationDate)]
}
